export default function (list, field) {
    const result = [];
    list.forEach(el => {
        if (!result.includes(el[field])) {
            result.push(el[field]);
        }
    })
    return result;
}